import { FC } from "react";
import { Row } from "../../../components/containers";
import { Heading } from "../../../components/typography";
import { useThemeStore } from "../../../stores";
import { SearchInput } from "../../../components/inputs";
import { JustifyContent } from "../../../components/containers/types";
import useHistoryPageStore from "../store";

const HistoryHeader: FC = () => {
  const theme = useThemeStore((s) => s.theme);

  const { searchTerm, setSearchTerm } = useHistoryPageStore();

  return (
    <Row
      style={{ margin: "1rem 0" }}
      justifyContent={JustifyContent.Between}
      className="history-header"
    >
      <Heading color={theme.textOnBg} size={20}>
        جستجو در رویدادها
      </Heading>

      <SearchInput
        value={searchTerm}
        setValue={setSearchTerm}
        style={{ maxWidth: 330 }}
      />
    </Row>
  );
};

export default HistoryHeader;
